import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

// Internal imports
import { SharedModule } from '@shared/shared.module';
import { DprRoutingModule } from './dpr-routing.module';
import { containerComponents } from './containers';
import { components } from './components';
import { services } from './services';
import { pipes } from './pipes';
import {
  DailyStockService,
  DprCarryOverFormulaCalculationService,
  DprFormulaCalculationService,
  ProgressStockService,
  WorkedHoursService,
} from '@dpr-details/services';
import {
  DprAccumulationOfflineService,
  DprConsumableOfflineService,
  DprDetailsOfflineRevisionService,
  DprDetailsOfflineService,
  DprDetailsOfflineSaveService,
  DprDetailsSyncModelBuilderService,
  DprDetailsSyncSanitizeService,
  DprHseOfflineService,
  DprPersonnelOfflineService,
  DprProgressOfflineService,
  CreateDprDetailsOfflineService,
  DprProgressWithoutTargetOfflineService,
} from '@dpr-details/services/sync';

@NgModule({
  declarations: [containerComponents, components, pipes],
  imports: [
    CommonModule,

    // internals
    SharedModule,
    DprRoutingModule,
  ],
  providers: [
    services,
    pipes,
    DatePipe,
    DprDetailsOfflineService,
    DprDetailsOfflineSaveService,
    DprDetailsSyncModelBuilderService,
    DprDetailsSyncSanitizeService,
    DprPersonnelOfflineService,
    DprConsumableOfflineService,
    DprHseOfflineService,
    DailyStockService,
    WorkedHoursService,
    DprDetailsOfflineRevisionService,
    DprProgressOfflineService,
    DprProgressWithoutTargetOfflineService,
    ProgressStockService,
    CreateDprDetailsOfflineService,
    DprAccumulationOfflineService,
    DprCarryOverFormulaCalculationService,
    DprFormulaCalculationService,
  ],
})
export class DprModule {}
